export const mapReportData = (data, itemRenderer, reverseWeeks = true) => {
  // Check if data structure is flat (week -> records) or nested (employeeId -> weeks -> records)
  const firstEntry = Object.values(data)[0];
  const isNestedStructure =
    firstEntry && typeof firstEntry === 'object' && !Array.isArray(firstEntry);

  if (isNestedStructure) {
    // Original nested structure: employeeId -> weeks -> records
    return Object.entries(data).flatMap(([employeeId, weeks]) =>
      Object.entries(weeks)
        .map(([week, records]) => {
          if (!records || records.length === 0) return null;

          // Take employee, employer, columns, source from first record (should be same for all records in week)
          const {
            employee = [],
            employer = [],
            columns = [],
            source = [],
            summary = [],
            footer = [],
          } = records[0];

          source.map(item => {
            item.employee = employee;
            item.employer = employer;
            return item;
          });

          return itemRenderer({
            id: `${employeeId}-${week}`,
            employee,
            employer,
            columns,
            source,
            summary,
            footer,
          });
        })
        .filter(Boolean)
        [reverseWeeks ? 'reverse' : 'slice'](),
    );
  } else {
    // Flat structure: week -> records
    return Object.entries(data)
      .map(([week, records]) => {
        if (!records || records.length === 0) return null;

        // Take employee, employer, columns, source from first record (should be same for all records in week)
        const {
          employee = [],
          employer = [],
          columns = [],
          source = [],
          summary = [],
          footer = [],
        } = records[0];

        return itemRenderer({
          id: week,
          employee,
          employer,
          columns,
          source,
          summary,
          footer,
        });
      })
      .filter(Boolean) // Remove null entries
      [reverseWeeks ? 'reverse' : 'slice']();
  }
};

// Specific function for holidays report flat structure
export const mapHolidaysReportData = (data, itemRenderer) => {
  // Holidays flat structure: employeeId -> reportObject
  return Object.entries(data)
    .map(([employeeId, reportData]) => {
      if (!reportData || typeof reportData !== 'object') return null;
      
      const { 
        id = employeeId,
        title = '',
        employee = [], 
        employer = [], 
        columns = [], 
        source = [], 
        summary = [], 
        footer = [] 
      } = reportData;

      return itemRenderer({
        id,
        title,
        employee,
        employer,
        columns,
        source,
        summary,
        footer,
      });
    })
    .filter(Boolean);
};
